export default "__VITE_ASSET__DAAPk6hi__"